import { MatDialogContent } from '@angular/material/dialog';

export interface ChatterCommandList {
  commands: ChatterCommand[];
}

export interface ChatterCommand {
  type: ChatterCommandType;
  expectedInput: ChatterInputType;
  message?: string;
  providedInput?: any;
  variableName?: string;
  entitySelectorFilters?: any;
  modalBlueprint?: MatDialogContent;
  isFinalStep?: boolean;
  finalActionLabel?: string;
  conditional?: boolean;
  conditions?: any[];
  canRender?: boolean;
  responseLabel?: string;
  skipMessage?: string;
  dataKey?: string;
  variableLabel?: string;
  field?: string;
  entityType?: string;
  typeNotFoundMessage?: string;
}

export enum ChatterCommandType {
  USER = 'USER',
  SYSTEM = 'SYSTEM'
}

export enum ChatterInputType {
  FREEFORM = 'FREEFORM',
  PROVIDED_SET = 'PROVIDED_SET',
  MODAL = 'MODAL',
  ENTITY_SELECTOR = 'ENTITY_SELECTOR',
  MULTI_SELECT = 'MULTI_SELECT',
  FINALIZE_FLOW = 'FINALIZE_FLOW',
  NILL = 'NILL',
  FROM_PROVIDED_DATA = 'FROM_PROVIDED_DATA'
}
